/* Отключване на бонусите според избраната оферта.

   Чете избраната стойност в продуктовата форма, вади броя чифтове от
   нея и отключва бонусите, чийто праг е достигнат. Работи и когато
   изборът се сменя, и при първоначално зареждане. */
(function () {
  'use strict';

  /* „2 чифта + 1 подарък“ -> 2 */
  function pairsFrom(text) {
    if (!text) return 0;
    var m = String(text).match(/(\d+)\s*чифт/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  function selectedPairs(scope) {
    var best = 0;

    // избрани радиота и падащи менюта в продуктовата форма
    var inputs = scope.querySelectorAll('input[type="radio"]:checked, select');
    Array.prototype.forEach.call(inputs, function (el) {
      var v = el.tagName === 'SELECT' ? (el.value || '') : (el.value || '');
      var n = pairsFrom(v);
      if (n > best) best = n;
    });

    // някои теми държат избора само в надписа
    if (best === 0) {
      var marks = scope.querySelectorAll('[aria-checked="true"], .is-selected, .selected');
      Array.prototype.forEach.call(marks, function (el) {
        var n = pairsFrom(el.textContent);
        if (n > best) best = n;
      });
    }
    if (window.LP_DEBUG) console.log("[бонуси] намерени чифтове:", best);
    return best;
  }

  function apply(root) {
    var lists = (root || document).querySelectorAll('[data-lp-bonus-list]');
    if (!lists.length) return;

    // формата на продукта; ако липсва — цялата страница
    // Радиотата на темата стоят извън формата и се връзват с атрибут form,
    // затова обхватът е цялата страница.
    var scope = document;
    var pairs = selectedPairs(scope);

    Array.prototype.forEach.call(lists, function (list) {
      var items = list.querySelectorAll('[data-lp-bonus-min]');
      Array.prototype.forEach.call(items, function (item) {
        var min = parseInt(item.dataset.lpBonusMin, 10) || 0;
        var open = pairs >= min;
        item.classList.toggle('is-locked', !open);
        var state = item.querySelector('[data-lp-bonus-state]');
        if (state) state.textContent = open ? (state.dataset.on || 'включено') : (state.dataset.off || '');
      });
    });
  }

  function init() {
    apply();
    // Shrine сменя избора без презареждане — следим цялата страница
    document.addEventListener('change', function () { setTimeout(apply, 40); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('label, [role="radio"], .quantity-breaks')) setTimeout(apply, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
})();
